export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Webhooks.json?hash=5641d65474798b482217d101f2672089";